import React from 'react';
import { LogoIcon, Select, Wrapper } from 'components';

const { Option } = Select;

const ItemStateSelect = ({
	editable = false,
	isLoading = false,
	onChange,
	options = [],
	placeholder,
	value,
}) => (
	<Wrapper
		padding='0'
		margin='0'
		justifyContent='left'
		onClick={event => event.stopPropagation()}
	>
		{isLoading ? (
			<LogoIcon spin />
		) : editable ? (
			<Select
				style={{ width: '100%' }}
				placeholder={placeholder}
				value={value}
				onChange={onChange}
			>
				{options.map(state => (
					<Option key={state.id} value={state.id}>
						<em>{state.name}</em>
					</Option>
				))}
			</Select>
		) : (
			<span>{placeholder}</span>
		)}
	</Wrapper>
);

export default ItemStateSelect;
